

















import { snakeCase } from 'lodash'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../../BotProperties/components/Properties/types'
import { SetPropertyActionValue } from '../../../../../../../../../../Flow/new/logic/Nodes/Communications/Action/logic/Actions/PropertyAction/types'
import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../Pi/types'
import { PropertyActionType } from '../../../../logic/Actions/PropertyAction/types'
import { ActionTypes } from '../../../../logic/Actions/types'

@Component({
  data() {
    return {
      snakeCase,
      ActionTypes,
    }
  }
})
export default class PropertyActionSelectPropertyActionValueType extends UseFields {
  @Prop() type!: SetPropertyActionValue

  @Prop() currentProperty!: GroupedBotProperty | undefined

  @Prop() action!: PropertyActionType

  @Prop() getPropertyActionValueTypes!: () => Array<SetPropertyActionValue>

  get propertyValueTypeOptions(): Array<SelectOptionData> {
    return this.getPropertyActionValueTypes()
      .map((t) => ({
        label: this.$t(`${ snakeCase(t) }_option`).toString(),
        value: t
      }))
  }

  setPropertyValueTypeHandler(arg: FieldData): FieldData {
    arg.setter = (type) => this.setValueType(type)
    return arg
  }

  @Emit()
  setValueType(type: SetPropertyActionValue): SetPropertyActionValue {
    return type
  }
}
